import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { NTA_COLORS, SCROLL_NAV_RIGHT_OFFSET } from '../constants';
import { ntaQuestionTitleCss } from '../typography';
import NtaCalculatorButton from './NtaCalculatorButton';
import NtaScrollNavButton, { NtaScrollNavSlot } from './NtaScrollNavButton';

const Row = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px ${SCROLL_NAV_RIGHT_OFFSET}px 8px 0;
  border-bottom: 1px solid ${NTA_COLORS.questionBorder};
`;

const Title = styled.h2`
  margin: 0;
  flex: 1;
  min-width: 0;
  ${ntaQuestionTitleCss}
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const NtaQuestionTitleRow = ({
  children,
  onScrollToBottom,
  showScrollToBottom = false
}) => (
  <Row>
    <Title>{children}</Title>
    <RightActions>
      <NtaCalculatorButton />
      <NtaScrollNavSlot>
        {onScrollToBottom && showScrollToBottom ? (
          <NtaScrollNavButton direction="down" onClick={onScrollToBottom} />
        ) : null}
      </NtaScrollNavSlot>
    </RightActions>
  </Row>
);

NtaQuestionTitleRow.propTypes = {
  children: PropTypes.node.isRequired,
  onScrollToBottom: PropTypes.func,
  showScrollToBottom: PropTypes.bool
};

export default NtaQuestionTitleRow;
